/*
 * Name: Featured Suppliers
 * Desc:
 *
 */
import React from "react"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import emailWhite from "@images/icons/emailWhite.svg"
import facebookWhite from "@images/icons/facebookWhite.svg"
import twitterWhite from "@images/icons/twitterWhite.svg"
import * as styles from "./ShareArticle.module.scss"

const ShareArticle = (props) => (
  <Section className={styles.ShareArticle}>
    <SiteWrapper narrow>
      <h2>Share Article</h2>
      <div className={styles.icons}>
        <a href={`mailto:?body=https%3A//${props.url}`} target="_blank" rel="noopener noreferrer">
          <img src={emailWhite} alt="email" />
        </a>
        <a
          href={`https://twitter.com/home?status=https%3A//${props.url}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={twitterWhite} alt="twitter" />
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=https%3A//${props.url}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={facebookWhite} alt="facebook" />
        </a>
      </div>
    </SiteWrapper>
  </Section>
)

export default ShareArticle
